import { Component, Inject, NgModule, OnInit } from '@angular/core';
import { MsalBroadcastService, MsalService, MsalGuardConfiguration, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { Subscription } from 'rxjs/internal/Subscription';
import { TranslateService } from '@ngx-translate/core';
import { GLOBAL_CONFIG } from './@core/data/globalConfig';
import { filter, takeUntil } from 'rxjs/operators';
import { AccountInfo, AuthenticationResult, EventMessage, EventType, InteractionType, IPublicClientApplication, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { RxService } from './@core/services/rx/rx.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  private subscription: Subscription;

  isIframe = false;
  loggedIn = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    public translate: TranslateService,
    private msalBroadcastService: MsalBroadcastService,
    private authMSALService: MsalService,
    private rxService: RxService
    
  ) {
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;

    this.checkoutAccount();
    
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS),
        takeUntil(this._destroying$)
      )
      .subscribe((result) => {
        let payload: any = result.payload;
        const accounts: AccountInfo[] = this.authMSALService.instance.getAllAccounts();
        this.authMSALService.instance.setActiveAccount(accounts[0]) 
        this.rxService.saveToken(payload.accessToken);
        this.checkoutAccount();
      });
    /*
    this.broadcastService.subscribe('msal:loginSuccess', () => {
      this.checkoutAccount();
    });

    this.subscription = this.broadcastService.subscribe('msal:acquireTokenSuccess', payload => {
      console.log(payload);
    });
    
    this.subscription = this.broadcastService.subscribe('msal:acquireTokenFailure', (authError: AuthError) => {
      // In case we cannot obtain the access token silently (MFA, session expired, etc...),
      // we present the authentication popup in order the user to satisfy the conditional
      // access. For more info check the link below:
      // https://docs.microsoft.com/en-us/azure/active-directory/develop/
      // msal-handling-exceptions?tabs=javascript#conditional-access-and-claims-challenges)

      if (authError.name === 'InteractionRequiredAuthError') {
        this.authMSALService.acquireTokenPopup({
          scopes: ['user.read', GLOBAL_CONFIG.config.apiScope]
        });
      }

    });
    */
    

  }

  // tslint:disable-next-line: use-lifecycle-interface
  ngOnDestroy(): void {
    this._destroying$.next(null);
    this._destroying$.complete();
  }

  checkoutAccount() {
    this.loggedIn = !!this.authMSALService.instance.getAllAccounts();
  }

  
  login() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      if (this.msalGuardConfig.authRequest){
        this.authMSALService.loginPopup({...this.msalGuardConfig.authRequest} as PopupRequest)
          .subscribe((response: AuthenticationResult) => {
            this.authMSALService.instance.setActiveAccount(response.account);
            this.checkoutAccount();
          });
        } else {
          this.authMSALService.loginPopup()
            .subscribe((response: AuthenticationResult) => {
              this.authMSALService.instance.setActiveAccount(response.account);
              this.checkoutAccount();
            });
      }
    } else {
      if (this.msalGuardConfig.authRequest){
        this.authMSALService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
      } else {
        this.authMSALService.loginRedirect();
      }
    }
  }
  logout() {
    this.authMSALService.logout();
  }

}
